import _toConsumableArray from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

function isPortableTextSpan(node) {
  return node._type === "span" && "text" in node && typeof node.text === "string" && (typeof node.marks === "undefined" || Array.isArray(node.marks) && node.marks.every(function (mark) {
    return typeof mark === "string";
  }));
}

function isPortableTextBlock(node) {
  return typeof node._type === "string" && node._type[0] !== "@" && (!("markDefs" in node) || Array.isArray(node.markDefs) && node.markDefs.every(function (def) {
    return typeof def._key === "string";
  })) && "children" in node && Array.isArray(node.children) && node.children.every(function (child) {
    return typeof child === "object" && "_type" in child;
  });
}

function isPortableTextListItemBlock(block) {
  return isPortableTextBlock(block) && "listItem" in block && typeof block.listItem === "string" && (typeof block.level === "undefined" || typeof block.level === "number");
}

function isPortableTextToolkitList(block) {
  return block._type === "@list";
}

function isPortableTextToolkitSpan(span) {
  return span._type === "@span";
}

function isPortableTextToolkitTextNode(node) {
  return node._type === "@text";
}

var knownDecorators = ["strong", "em", "code", "underline", "strike-through"];

function sortMarksByOccurences(span, index, blockChildren) {
  if (!isPortableTextSpan(span) || !span.marks) {
    return [];
  }

  if (!span.marks.length) {
    return [];
  }

  var marks = span.marks.slice();
  var occurences = {};
  marks.forEach(function (mark) {
    occurences[mark] = 1;

    for (var siblingIndex = index + 1; siblingIndex < blockChildren.length; siblingIndex++) {
      var sibling = blockChildren[siblingIndex];

      if (sibling && isPortableTextSpan(sibling) && Array.isArray(sibling.marks) && sibling.marks.indexOf(mark) !== -1) {
        occurences[mark]++;
      } else {
        break;
      }
    }
  });
  return marks.sort(function (markA, markB) {
    return sortMarks(occurences, markA, markB);
  });
}

function sortMarks(occurences, markA, markB) {
  var aOccurences = occurences[markA];
  var bOccurences = occurences[markB];

  if (aOccurences !== bOccurences) {
    return bOccurences - aOccurences;
  }

  var aKnownPos = knownDecorators.indexOf(markA);
  var bKnownPos = knownDecorators.indexOf(markB);

  if (aKnownPos !== bKnownPos) {
    return aKnownPos - bKnownPos;
  }

  return markA.localeCompare(markB);
}

function buildMarksTree(block) {
  var _a;

  var children = block.children,
      _block$markDefs = block.markDefs,
      markDefs = _block$markDefs === void 0 ? [] : _block$markDefs;

  if (!children || !children.length) {
    return [];
  }

  var sortedMarks = children.map(sortMarksByOccurences);
  var rootNode = {
    _type: "@span",
    children: [],
    markType: "<unknown>"
  };
  var nodeStack = [rootNode];

  for (var i = 0; i < children.length; i++) {
    var span = children[i];

    if (!span) {
      continue;
    }

    var marksNeeded = sortedMarks[i] || [];
    var pos = 1;

    if (nodeStack.length > 1) {
      for (pos; pos < nodeStack.length; pos++) {
        var mark = ((_a = nodeStack[pos]) == null ? void 0 : _a.markKey) || "";
        var index = marksNeeded.indexOf(mark);

        if (index === -1) {
          break;
        }

        marksNeeded.splice(index, 1);
      }
    }

    nodeStack = nodeStack.slice(0, pos);
    var currentNode = nodeStack[nodeStack.length - 1];

    if (!currentNode) {
      continue;
    }

    var _iterator2 = _createForOfIteratorHelper(marksNeeded),
        _step2;

    try {
      var _loop = function _loop() {
        var markKey = _step2.value;
        var markDef = markDefs.find(function (def) {
          return def._key === markKey;
        });
        var markType = markDef ? markDef._type : markKey;
        var node = {
          _type: "@span",
          _key: span._key,
          children: [],
          markDef: markDef,
          markType: markType,
          markKey: markKey
        };
        currentNode.children.push(node);
        nodeStack.push(node);
        currentNode = node;
      };

      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    if (isPortableTextSpan(span)) {
      var lines = span.text.split("\n");

      for (var line = lines.length; line-- > 1;) {
        lines.splice(line, 0, "\n");
      }

      currentNode.children = currentNode.children.concat(lines.map(function (text) {
        return {
          _type: "@text",
          text: text
        };
      }));
    } else {
      currentNode.children = currentNode.children.concat(span);
    }
  }

  return rootNode.children;
}

function nestLists(blocks, mode) {
  var tree = [];
  var currentList;

  for (var i = 0; i < blocks.length; i++) {
    var block = blocks[i];

    if (!block) {
      continue;
    }

    if (!isPortableTextListItemBlock(block)) {
      tree.push(block);
      currentList = void 0;
      continue;
    }

    if (!currentList) {
      currentList = listFromBlock(block, i, mode);
      tree.push(currentList);
      continue;
    }

    if (blockMatchesList(block, currentList)) {
      currentList.children.push(block);
      continue;
    }

    if ((block.level || 1) > currentList.level) {
      var newList = listFromBlock(block, i, mode);

      if (mode === "html") {
        var lastListItem = currentList.children[currentList.children.length - 1];

        var newLastChild = __spreadProps(__spreadValues({}, lastListItem), {
          children: [].concat(_toConsumableArray(lastListItem.children), [newList])
        });

        currentList.children[currentList.children.length - 1] = newLastChild;
      } else {
        currentList.children.push(newList);
      }

      currentList = newList;
      continue;
    }

    if ((block.level || 1) < currentList.level) {
      var matchingBranch = tree[tree.length - 1];
      var match = matchingBranch && findListMatching(matchingBranch, block);

      if (match) {
        currentList = match;
        currentList.children.push(block);
        continue;
      }

      currentList = listFromBlock(block, i, mode);
      tree.push(currentList);
      continue;
    }

    if (block.listItem !== currentList.listItem) {
      var _matchingBranch = tree[tree.length - 1];

      var _match = _matchingBranch && findListMatching(_matchingBranch, {
        level: block.level || 1
      });

      if (_match && _match.listItem === block.listItem) {
        currentList = _match;
        currentList.children.push(block);
        continue;
      } else {
        currentList = listFromBlock(block, i, mode);
        tree.push(currentList);
        continue;
      }
    }

    console.warn("Unknown state encountered for block", block);
    tree.push(block);
  }

  return tree;
}

function blockMatchesList(block, list) {
  return (block.level || 1) === list.level && block.listItem === list.listItem;
}

function listFromBlock(block, index, mode) {
  return {
    _type: "@list",
    _key: "".concat(block._key || "".concat(index), "-parent"),
    mode: mode,
    level: block.level || 1,
    listItem: block.listItem,
    children: [block]
  };
}

function findListMatching(rootNode, matching) {
  var level = matching.level || 1;
  var style = matching.listItem || "normal";
  var filterOnType = typeof matching.listItem === "string";

  if (isPortableTextToolkitList(rootNode) && (rootNode.level || 1) === level && filterOnType && (rootNode.listItem || "normal") === style) {
    return rootNode;
  }

  if (!("children" in rootNode)) {
    return void 0;
  }

  var node = rootNode.children[rootNode.children.length - 1];
  return node && !isPortableTextSpan(node) ? findListMatching(node, matching) : void 0;
}

var leadingSpace = /^\s/;
var trailingSpace = /^\s/;

function toPlainText(block) {
  var blocks = Array.isArray(block) ? block : [block];
  var text = "";
  blocks.forEach(function (current, index) {
    if (!isPortableTextBlock(current)) {
      return;
    }

    var pad = false;
    current.children.forEach(function (span) {
      if (isPortableTextSpan(span)) {
        text += pad && text && !trailingSpace.test(text) && !leadingSpace.test(span.text) ? " " : "";
        text += span.text;
        pad = false;
      } else {
        pad = true;
      }
    });

    if (index !== blocks.length - 1) {
      text += "\n\n";
    }
  });
  return text;
}

function spanToPlainText(span) {
  var text = "";
  span.children.forEach(function (current) {
    if (isPortableTextToolkitTextNode(current)) {
      text += current.text;
    } else if (isPortableTextToolkitSpan(current)) {
      text += spanToPlainText(current);
    }
  });
  return text;
}

var LIST_NEST_MODE_HTML = "html";
var LIST_NEST_MODE_DIRECT = "direct";
export { LIST_NEST_MODE_DIRECT, LIST_NEST_MODE_HTML, buildMarksTree, isPortableTextBlock, isPortableTextListItemBlock, isPortableTextSpan, isPortableTextToolkitList, isPortableTextToolkitSpan, isPortableTextToolkitTextNode, nestLists, sortMarksByOccurences, spanToPlainText, toPlainText };